export default __webpack_public_path__ + "static/media/핵심요약__민사고가 3년 전액 장학생 21명을 찾습니다.4774ab99.pdf";